
declare var tinyMCE: any;
module dg.objects {
    interface IWysiwygScope extends ng.IScope {

        domainObjectCtrl: ObjectEditorController;
        propMeta: dg.restfulApi.DomainObjectPropertyMetadata;
        htmlValue: string;
        isEditMode: boolean;
        switchToPreview(): void;
        switchToEdit(event: JQueryEventObject): void;
        $sce: ng.ISCEService;
        form;
        getSelectedText(): string;
        isElementInEditor(element: EventTarget): boolean;
        lastClickedElement: EventTarget;
        onMouseDown(event: JQueryEventObject);
        onMouseUp(event: JQueryEventObject);
        model: any;

    }

    interface IWysiwygAttributes extends ng.IAttributes {
        ngModel: string;
        id: string;
        name: string;
    }


    function dgWysiwyg($timeout: ng.ITimeoutService, $document: ng.IDocumentService, $sce: ng.ISCEService,
        $q: ng.IQService/*, Office365UrlService: dgComponents.files.Office365UrlService*/): ng.IDirective {
        return <ng.IDirective>{
            restrict: 'A',
            scope: true,
            require: ['ngModel', '^objectEditor'],
            templateUrl: '/digmo/src/objects/properties/text/wysiwyg.html',
            compile: (templateElement: ng.IAugmentedJQuery, templateAttributes: IWysiwygAttributes, transclude: ng.ITranscludeFunction) => {
                //var editTemplate = '<wysiwyg ng-show="isEditMode" ng-disabled="propMeta.readOnly" textarea-class="form-control wysiwyg" textarea-height="auto" ng-model="' + templateAttributes.ngModel + '"></wysiwyg>';

                //var editTemplate = '<div ng-show="isEditMode"><textarea ui-tinymce class="form-control wysiwyg" ng-model="' + templateAttributes.ngModel + '"></textarea></div>';
                //var previewTemplate = '<div ng-hide="isEditMode" ng-click="switchToEdit($event)" class="wysiwyg-preview panel panel-default" ><div class="panel-body" ng-bind-html="$sce.trustAsHtml(' + templateAttributes.ngModel + ')"></div></div>';
                //var previewElement = angular.element(previewTemplate);
                //templateElement.html(editTemplate);
                //templateElement.append(previewElement);

                //New comment
                //templateElement.find('*[ui-tinymce]').attr('ng-model', templateAttributes.ngModel);
                //templateElement.find('.wysiwyg-preview .wysiwyg-body').attr('ng-bind-html', '$sce.trustAsHtml(' + templateAttributes.ngModel +')')
                return (scope: IWysiwygScope, element: ng.IAugmentedJQuery, attrs: IWysiwygAttributes, ctrls) => {
                    var ngModelCtrl = <ng.INgModelController>ctrls[0];
                    scope.form[scope.propMeta.id] = ngModelCtrl;

                    var saveHtmlValueDeferred = $q.defer();
                    var fileId = null;
                    var dataReceived = false;
                    
                    scope.htmlValue = null;
                    scope.domainObjectCtrl = ctrls[1];
                    scope.$sce = $sce;
                    scope.isEditMode = false;
                    scope.switchToPreview = () => {
                        scope.isEditMode = false;
                    }

                    scope.getSelectedText = () => {
                        if (window.getSelection) { return window.getSelection().toString(); }
                        else if (document.getSelection) { return document.getSelection().toString(); }
                        else {
                            //REMOVE: document DOES NOT have selection property 
                            //var selection = document.selection && document.selection.createRange();
                            //if (selection.text) { return selection.text; }
                            return null;
                        }
                    }
                    scope.isElementInEditor = (el) => {
                        return element.find(el).length != 0
                            || angular.element('.mce-container').find(el).length != 0;
                    };

                    scope.onMouseDown = (event: JQueryEventObject) => {
                        scope.$apply(() => {
                            scope.lastClickedElement = event.target;
                        });
                    };

                    scope.onMouseUp = (event: JQueryEventObject) => {
                        var clickStartInEditor = scope.isElementInEditor(scope.lastClickedElement);
                        var clickEndInEditor = scope.isElementInEditor(event.target);
                        if (!clickStartInEditor && !clickEndInEditor) {
                            scope.$apply(() => {
                                scope.switchToPreview();
                                $document
                                    .off('mousedown', scope.onMouseDown)
                                    .off('mouseup', scope.onMouseUp);
                            });
                        }
                    };

                    scope.switchToEdit = (event) => {
                        var isReadOnly = scope.propMeta.readOnly; //|| scope.domainObjectCtrl.disabledActions.all;
                        var selectedText = scope.getSelectedText();
                        if (isReadOnly || angular.element(event.target).is('a')
                            || (selectedText != null && selectedText != '')) {
                            return;
                        }
                        scope.isEditMode = true;
                        //$document.bind('click', scope.hideEditor);

                        $document
                            .on('mousedown', scope.onMouseDown)
                            .on('mouseup', scope.onMouseUp);
                        $timeout(function () {
                            //element.find('.wysiwyg').focus();
                            var currEditor = tinyMCE.get(element.find('textarea').attr('id'));
                            currEditor.focus();
                            currEditor.selection.setCursorLocation(0, 0);
                        });
                    };

                    //validations and ng-model
                    //scope.form[scope.propMeta.id] = ngModelCtrl;
                    //var stopNgModelWatch = scope.$watch(attrs.ngModel, function (value, oldValue) {
                    //    if (value != oldValue) {
                    //        scope.form[scope.propMeta.id].$pristine = false;
                    //        scope.form[scope.propMeta.id].$dirty = true;
                    //        stopNgModelWatch();
                    //    }
                    //});


                    var stopNgModelWatch = scope.$watch(attrs.ngModel, (value: string) => {

                        if (value) {
                            fileId = value;
                            getHtmlValue().then((val) => {
                                scope.htmlValue = val;
                              
                                $timeout(function () {
                                    dataReceived = true;
                                });
                            }, angular.noop);
                        }
                        ctrls[1].registerInvokePredicesor(htmlValuePromiseFunction);

                        stopNgModelWatch();
                    });

                    var stopHtmlValueWatch = scope.$watch("htmlValue", (value, oldValue) => {
                        if (dataReceived) {
                            if (value != oldValue) {
                                scope.form[scope.propMeta.id].$pristine = false;
                                scope.form[scope.propMeta.id].$dirty = true;
                                stopHtmlValueWatch();
                            }
                        }
                    });

                    function getHtmlValue() {
                        var deferred = $q.defer<string>();

                        //TODO: FIX
                        //Office365UrlService.downloadFile(fileId).then((data: string) => {
                        //    deferred.resolve(data);
                        //}, (errorData) => {
                        //    errorData.data = {
                        //        message: 'Error in request'
                        //    }
                        //});

                        return deferred.promise;
                    }

                    var htmlValuePromiseFunction = function () {
                        return saveHtmlValue();
                    };

                    function saveHtmlValue() {
                        var deferred = $q.defer<{}>();

                        $timeout(function () {
                            var domainObject = ctrls[1].getDomainObject();

                            //TODO: FIX
                            //Office365UrlService.uploadFile(domainObject.externalDataFolderId, scope.propMeta.id + ".html", true, "text/html", scope.htmlValue).then((data: any) => {
                            //    ctrls[0].$setViewValue(data.id);
                            //    deferred.resolve();
                            //})
                        }, 1000);
                        //create new file and set fileContent externalDataFolderId

                        return deferred.promise;
                    }

                }
            }
        };
    }
    dgWysiwyg.$inject = [
        '$timeout',
        '$document',
        '$sce',
        '$q',
        'Offilce365UrlService'
    ];

    angular.module('dg.objects')
        .directive('dgWysiwyg', dgWysiwyg)
        .run(['uiTinymceConfig', (uiTinymceConfig) => {
            var tinymceOptions = {
                menubar: false,
                statusbar: false,
                plugins: 'link autoresize textcolor',
                toolbar: 'bold italic underline | styleselect | forecolor backcolor | removeformat | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | link unlink',
                style_formats: [
                    { title: "Paragraph", format: "p" },
                    { title: "Header 1", format: "h1" },
                    { title: "Header 2", format: "h2" },
                    { title: "Header 3", format: "h3" },
                    { title: "Header 4", format: "h4" },
                    { title: "Header 5", format: "h5" },
                    { title: "Header 6", format: "h6" }
                ],
                height: 'auto',
                resize: false
            };
            uiTinymceConfig = dgUtils.ObjectHelperService.mergeDeep(uiTinymceConfig, tinymceOptions);
        }]);
} 